var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoldUsersUserPlusRounded = function SvgBoldUsersUserPlusRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 10,
    r: 6.667,
    fill: "#DCD9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCD9FF",
    fillRule: "evenodd",
    d: "M27.5 36.667c-2.75 0-4.125 0-4.98-.855-.854-.854-.854-2.229-.854-4.979s0-4.124.855-4.979C23.375 25 24.75 25 27.5 25s4.125 0 4.979.854c.854.855.854 2.23.854 4.98s0 4.124-.854 4.978-2.23.855-4.98.855m.972-8.426a.972.972 0 0 0-1.944 0v1.62h-1.62a.972.972 0 0 0 0 1.945h1.62v1.62a.972.972 0 1 0 1.944 0v-1.62h1.62a.972.972 0 1 0 0-1.945h-1.62z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCD9FF",
    d: "M25.691 22.512c-1.683-.538-3.624-.845-5.69-.845-6.444 0-11.667 2.984-11.667 6.666 0 3.568 4.904 6.481 11.07 6.659q-.067-.317-.108-.625c-.13-.963-.13-2.14-.13-3.39v-.287c0-1.25 0-2.427.13-3.39.144-1.072.488-2.244 1.457-3.213.97-.97 2.142-1.314 3.214-1.458.52-.07 1.102-.102 1.724-.117"
  })));
};
export default SvgBoldUsersUserPlusRounded;